//import type { Cart } from '@medusajs/medusa';
import { RightArrowIcon } from '@wolfejs/icons/IconMap';
import { FormattedCart } from '@wolfejs/ms-api-js/src/types/orders';
import { Button } from '@wolfejs/ui/Button';
import { Divider } from '@wolfejs/ui/Divider';
import { FormatCurrency } from '@wolfejs/ui/Format';
import { cn } from '@wolfejs/ui/utils/classnames';
import translations from '../../i18n/en';

export type OrderSummaryProps = {
  className?: string;
  shippingMethodSelectedPrice?: number | null;
  cart?: FormattedCart | null;
  buttonText: string;
  buttonOnClick: () => void;
  linkText?: string;
  linkOnClick?: () => void;
  isLoading?: boolean;
};

const formatMoney = (amount: number) => {
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
  return formatted;
};

export const OrderSummary = ({
  className,
  shippingMethodSelectedPrice,
  cart,
  buttonText,
  buttonOnClick,
  linkText,
  linkOnClick,
  isLoading = false,
}: OrderSummaryProps) => {
  const { tax_total } = cart || {};

  const getTotal = () => {
    let total = 0;
    if (cart?.items && cart.items[0]) {
      for (const item of cart.items) {
        total += item.total ?? 0;
      }
    }
    return shippingMethodSelectedPrice ? total + shippingMethodSelectedPrice : total;
  };

  const getDiscountTotal = () => {
    return cart?.discount_total ?? 0;
  };

  const getTotalItems = () => {
    // let total = 0;
    // if (cart?.items && cart.items[0]) {
    //   for (const item of cart.items) {
    //     for (const subItem of item.metadata.items as any) {
    //       total += subItem.denomination * 100;
    //     }
    //   }
    // }
    return cart?.subtotal;
  };

  return (
    <div className={cn('@container', className)}>
      <div
        className={cn(
          'flex flex-col gap-y-1',
          // breakpoints
          '@md:gap-y-2'
        )}
      >
        <div className="flex justify-between">
          <span>{translations.originalPrice}</span>
          <span className="font-medium">{formatMoney(cart?.subtotal ?? 0)}</span>
        </div>
        {getDiscountTotal() > 0 && (
          <div className="flex justify-between">
            <span>{translations.savings}</span>
            <span className="text-success-600 font-medium">
              - <span>{formatMoney(cart?.discount_total ?? 0)}</span>
            </span>
          </div>
        )}
        <div className="flex justify-between">
          <span>{translations.estimatedShipping}</span>
          <FormatCurrency
            numberFormatBaseProps={{
              value: shippingMethodSelectedPrice,
              displayType: 'text',
            }}
          />
        </div>
        {/* TODO Need fees_total defined as part of Medusa backend */}
        {/* {!!fees_total && (
          <div className="flex justify-between">
            <span>{translations.fees}</span>
            <span className="font-medium">{getAmount(fees_total)}</span>
          </div>
        )} */}

        {!!tax_total && (
          <div className="flex justify-between">
            <span>{translations.taxes}</span>
            <span className="font-medium">{tax_total}</span>
          </div>
        )}
      </div>
      <Divider className="border-default-100" />
      <div className="text-ui-fg-base txt-medium mb-4 flex justify-between font-bold">
        <span>{translations.total}</span>
        <span>{formatMoney(getTotal())}</span>
      </div>
      <Button
        className="mb-2 h-10 w-full text-white"
        color="primary"
        variant="solid"
        onClick={buttonOnClick}
        loading={isLoading}
      >
        {buttonText}
      </Button>
      {linkText && linkOnClick ? (
        <div className="flex w-full justify-center">
          <span className="text-default">or </span>
          <Button className="text-primary hover:text-primary-500 ml-2" variant="link" onClick={linkOnClick}>
            <span className="underline">{linkText}</span>
            <span className="ml-2">
              <RightArrowIcon size={16} />
            </span>
          </Button>
        </div>
      ) : null}
    </div>
  );
};
